// Entry de /recursos/: conversión + modal de descarga de scripts (email-gate).
// Sin 3D. Postea al endpoint estático /download-script.php (honeypot + time-trap).
import { initReveals } from './ui/reveals'
import { initConversion } from './ui/conversion'
import { initCalModal } from './ui/calmodal'
import { initMenu } from './ui/menu'
import { captureGclid } from './analytics/gclid'
import { appendFormToken } from './ui/formToken'

document.documentElement.classList.add('js')

captureGclid()
initReveals()
initConversion()
initMenu()
initCalModal()
initScriptDownload()

interface ScriptInfo { name: string; hasSingle: boolean }

const SCRIPT_DATA: Record<string, ScriptInfo> = {
  'account-anomaly-detector': { name: 'Account Anomaly Detector', hasSingle: true },
  'broken-link-checker': { name: 'Broken Link Checker', hasSingle: true },
  'change-history-alerts': { name: 'Change History Alerts', hasSingle: true },
  'disapproved-ads-alert': { name: 'Disapproved Ads Alert', hasSingle: true },
  'google-display-network-alert': { name: 'Google Display Network Enabled Alert', hasSingle: true },
  'search-partner-alerts': { name: 'Search Partner Alerts', hasSingle: true },
  'negative-keywords-suggestions': { name: 'Negative Keywords Suggestions', hasSingle: true },
  'negative-keyword-list-builder': { name: 'Negative Keyword List Builder', hasSingle: true },
  'duplicate-keyword-checker': { name: 'Duplicate Competing Keyword Checker', hasSingle: true },
  'close-variants-report': { name: 'Close Variants Report', hasSingle: true },
  'qs-analysis-report': { name: 'QS Analysis Report', hasSingle: true },
  'trending-search-terms': { name: 'Trending Search Terms', hasSingle: true },
  'daily-trending-search-terms': { name: 'Report Trending Search Terms Daily', hasSingle: true },
  'pmax-trending-categories': { name: 'Performance Max Trending Search Categories', hasSingle: true },
  'word-count-shopping': { name: 'Word Count Analysis for Shopping Item Titles', hasSingle: true },
  'search-partner-performance': { name: 'Search Partner Performance', hasSingle: true },
  'gemini-model-scanner': { name: 'Gemini API Model Scanner', hasSingle: false },
  'keywords-to-negative': { name: 'Keywords to Negative List', hasSingle: true },
  'ngram-report': { name: 'Search Query Mining N-gram Report', hasSingle: true },
  'god-tier-search-terms': { name: 'God Tier Search Terms Report', hasSingle: true },
  'gta-weekly': { name: 'GTA Weekly Jalapeño', hasSingle: false },
  'ai-copywriting-agent': { name: 'Jalapeños AI Copywriting Agent', hasSingle: false },
  'pmax-insights': { name: 'PMax Insights', hasSingle: false },
  'revenue-maximiser': { name: 'Revenue Maximiser Tiering Script', hasSingle: true },
}

function initScriptDownload(): void {
  const modal = document.getElementById('download-modal')
  const form = document.getElementById('download-form') as HTMLFormElement | null
  if (!modal || !form) return

  const overlay = modal.querySelector<HTMLElement>('.script-modal__overlay')
  const closeBtn = modal.querySelector<HTMLElement>('.script-modal__close')
  const successEl = document.getElementById('modal-success')
  const errorEl = document.getElementById('modal-error')
  const scriptIdInput = document.getElementById('modal-script-id') as HTMLInputElement | null
  const scriptNameEl = document.getElementById('modal-script-name')
  const versionNote = document.getElementById('version-note')
  const versionSel = document.getElementById('version-selector') as HTMLElement | null
  const tsInput = form.querySelector<HTMLInputElement>('input[name="ts"]')

  function setErr(msg: string): void {
    if (!errorEl) return
    const p = errorEl.querySelector('p')
    if (p) p.textContent = msg
    errorEl.hidden = false
  }

  function openModal(scriptId: string): void {
    const data = SCRIPT_DATA[scriptId]
    if (!data || !scriptIdInput) return
    scriptIdInput.value = scriptId
    if (scriptNameEl) scriptNameEl.textContent = '[ ' + data.name + ' ]'
    if (versionSel && versionNote) {
      if (data.hasSingle) {
        versionSel.style.display = 'flex'
        versionNote.textContent = 'Cuenta cliente: corre directo en la cuenta del anunciante. MCC: gestión desde la cuenta administradora.'
      } else {
        versionSel.style.display = 'none'
        versionNote.textContent = 'Este script tiene una sola versión.'
      }
    }
    form!.style.display = ''
    if (successEl) successEl.hidden = true
    if (errorEl) errorEl.hidden = true
    form!.reset()
    scriptIdInput.value = scriptId
    const single = form!.querySelector<HTMLInputElement>('input[value="single"]')
    const mcc = form!.querySelector<HTMLInputElement>('input[value="mcc"]')
    if (data.hasSingle) { if (single) single.checked = true } else { if (mcc) mcc.checked = true }
    const nl = form!.querySelector<HTMLInputElement>('input[name="newsletter"]')
    if (nl) nl.checked = true
    if (tsInput) tsInput.value = String(Date.now())
    modal!.hidden = false
    document.body.style.overflow = 'hidden'
    form!.querySelector<HTMLInputElement>('input[type="text"]')?.focus()
  }

  function closeModal(): void {
    modal!.hidden = true
    document.body.style.overflow = ''
  }

  document.querySelectorAll<HTMLElement>('[data-download-script]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      openModal(btn.dataset.downloadScript || '')
    })
  })
  overlay?.addEventListener('click', closeModal)
  closeBtn?.addEventListener('click', closeModal)
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) closeModal() })

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    const submitBtn = form.querySelector<HTMLButtonElement>('.btn-download-submit')
    if (submitBtn) { submitBtn.textContent = 'Enviando…'; submitBtn.disabled = true }
    if (errorEl) errorEl.hidden = true
    try {
      const data = new FormData(form)
      appendFormToken(data)
      const res = await fetch('/download-script.php', { method: 'POST', body: data })
      const result = await res.json() as { success: boolean; data?: { redirect?: string } | string }
      if (result.success) {
        const redirect = result.data && typeof result.data === 'object' ? result.data.redirect : undefined
        if (redirect) {
          setTimeout(() => { window.location.href = redirect }, 400)
        } else {
          form.style.display = 'none'
          if (successEl) successEl.hidden = false
        }
      } else {
        setErr(typeof result.data === 'string' ? result.data : 'Error al procesar. Intenta de nuevo.')
      }
    } catch {
      setErr('Error de conexión. Intenta de nuevo.')
    } finally {
      if (submitBtn) { submitBtn.textContent = 'Enviar y descargar →'; submitBtn.disabled = false }
    }
  })
}
